import { render, staticRenderFns } from "./reportManage.vue?vue&type=template&id=5031b134&scoped=true&"
import script from "./reportManage.vue?vue&type=script&lang=js&"
export * from "./reportManage.vue?vue&type=script&lang=js&"
import style0 from "./reportManage.vue?vue&type=style&index=0&id=5031b134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031b134",
  null
  
)

export default component.exports